var indentation_default = {
  "indentZero": "qufKF",
  "indentOne": "uMm-G",
  "indentTwo": "_0tNnd",
  "indentThree": "m2-Pk",
  "indentFour": "bGsiR",
  "indentFive": "DmOLR",
  "indentSix": "RXcYH"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
